const binding = { modules: {}, dataActions: {} };

    (binding.modules['flipp'] = {
        c: () => require('partner/modules/flipp/flipp.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'flipp',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/flipp'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|flipp|flipp'] = {
                c: () => require('partner/modules/flipp/flipp.view.tsx'),
                cn: '__local__-__local__-flipp'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };